import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c9788a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"font-size":"15px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"15px"},
  class: "text-center q-mb-md"
}, "Способ оплаты", -1))
const _hoisted_4 = {
  key: 0,
  class: "row justify-center q-mt-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_pay_btn = _resolveComponent("pay-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_banner, {
      style: {"margin-bottom":"20px"},
      class: "onl-bill-banner bg-primary text-white text-center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createTextVNode(" Счет: " + _toDisplayString(_ctx.checkData.doc_num) + " от " + _toDisplayString(_ctx.checkData.doc_date) + " ", 1),
          _hoisted_2,
          _createTextVNode(" к оплате по счету " + _toDisplayString(_ctx.checkData.PaySum.toLocaleString("ru-RU", {
            style: "currency",
            currency: "RUB",
          })), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_input, {
      class: "onl-bill-input",
      outlined: "",
      ref: "fio",
      modelValue: _ctx.userData.fio,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userData.fio) = $event)),
      modelModifiers: { trim: true },
      label: "Фио",
      rules: [
        (val) =>
          (val.length >= 3 && val.split(' ').length > 1) ||
          'Введите корректные ФИО',
      ]
    }, null, 8, ["modelValue", "rules"]),
    _createVNode(_component_vue_tel_input, {
      class: "onl-bill-phone-input",
      inputOptions: {
        placeholder: 'Введите номер телефона с кодом страны',
      },
      mode: "international",
      modelValue: _ctx.userData.phone,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userData.phone) = $event)),
      style: _normalizeStyle({
        'margin-bottom': _ctx.phoneBlurred && !_ctx.phoneValid ? '0px' : '20px',
        border: _ctx.phoneBlurred && !_ctx.phoneValid ? `solid 2px ${_ctx.negativeColor}` : '',
      }),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.phoneBlurred = true)),
      onOnInput: _cache[3] || (_cache[3] = 
          (formNumb, input) => {
            _ctx.phoneValid = input.valid;
          }
        )
    }, null, 8, ["modelValue", "style"]),
    _createVNode(_Transition, {
      name: "slide-fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.phoneBlurred && !_ctx.phoneValid)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle([{"font-size":"12px","margin-left":"12px","margin-top":"5px","margin-bottom":"5px"}, { color: _ctx.negativeColor }])
            }, " Введите корректный номер телефона ", 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_q_input, {
      outlined: "",
      ref: "email",
      class: "onl-bill-input",
      modelValue: _ctx.userData.email,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userData.email) = $event)),
      modelModifiers: { trim: true },
      label: "E-mail",
      rules: [
        (val) =>
          (val.match(/^\S+@\S+\.\S+$/) === null ? false : true) ||
          'Введите корректную почту',
      ]
    }, null, 8, ["modelValue", "rules"]),
    _hoisted_3,
    (_ctx.billData.paymentType?.bank)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.billData.paymentType?.allowSPB)
            ? (_openBlock(), _createBlock(_component_pay_btn, {
                key: 0,
                class: "q-mr-sm",
                bank: _ctx.billData.paymentType.bank,
                "payment-method": 'sbp',
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validate('sbp')))
              }, null, 8, ["bank"]))
            : _createCommentVNode("", true),
          (_ctx.billData.paymentType?.allowDeep)
            ? (_openBlock(), _createBlock(_component_pay_btn, {
                key: 1,
                class: "q-mr-sm",
                bank: _ctx.billData.paymentType.bank,
                "payment-method": 'deep',
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validate('deep')))
              }, null, 8, ["bank"]))
            : _createCommentVNode("", true),
          (_ctx.billData.paymentType?.allowCard)
            ? (_openBlock(), _createBlock(_component_pay_btn, {
                key: 2,
                bank: _ctx.billData.paymentType.bank,
                "payment-method": 'card',
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validate('card')))
              }, null, 8, ["bank"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}